import Dropdown from "react-bootstrap/Dropdown";
import React, { useEffect, useState } from "react";
import { CommentPropType } from "../../PropTypes";
import Modal from "../Modal/Modal";
import EditContributionModal from "../Modals/EditContributionModal";
import { isSpace } from "../../helpers/keyHelper";
import { encodeProfileURL } from '../../helpers/urlHelper';
import { removeSpaces } from "../../helpers/utilities";
function CommentOptions(props) {
  const [showEditModal, setShowEditModal] = useState(false);
  const {
    REACT_APP_IMAGEPATH,
  } = process.env;
  const ellipsis = `${REACT_APP_IMAGEPATH}/ellipsis-icon.png`;

  var options = [];

  const standardOptions = props.profilePage
    ? ["Edit", "Close"]
    : ["View My Profile", "Edit", "Close"];
  // Options to appear on a users own pending comment
  if (props.comment.isLoggedInUsersComment) {
    options = standardOptions;
  } else if (props.comment.username === "Anonymous User") {
    options = ["Close"];
  } else {
    // Options to appear on other users comments
    options = ["View Profile", "Close"];
  }

  function handleMenuKeyPress(e) {
    if (isSpace(e)) {
      e.preventDefault();
      e.target.click();
    }
  }

  // Click handler for each option in dropdown
  function handleDropDownItemClick(option, e) {
    switch (option) {
      case "Edit":
        handleEditButtonClick();
        break;
      case "View Profile":
      case "View My Profile":
        handleViewProfileButtonClick();
        break;
      case "Close":
        handleCloseButtonClick(e);
        break;
      default:
        break;
    }
  }

  function handleEditButtonClick() {
    setShowEditModal(true);
  }

  function handleCloseButtonClick(e) {
    e.target.show = false;
  }

  function handleViewProfileButtonClick() {
    if(props.comment.isCreatedByOrganisationUser) {
      window.location = encodeProfileURL(props.comment.username);
    } else {
      window.location = encodeProfileURL(removeSpaces(props.comment.username), props.comment.memberId);
    }
  }

  // Creating a custom button to be displayed as the dropdown
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div className="ugc-comment-options">
      <span className="ugc-comment-options__title">
        Options
      </span>
      <a
        href="/#"
        className="ugc-comment-options__icon"
        ref={ref}
        onKeyDown={handleMenuKeyPress}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}>
        <img
          className="ugc-comment-options__icon-img"
          alt="Options"
          height="25"
          width="25"
          src={ellipsis}/>
        {children}
      </a>
    </div>
  ));

  const closeRootModal = () => {
    setShowEditModal(false);
    window.removeEventListener('popstate', closeRootModal);
  };

  useEffect(() => {
    document.documentElement.style.overflow = showEditModal ? 'hidden' : '';
    showEditModal && window.history.pushState({}, '');
    showEditModal && window.addEventListener('popstate', closeRootModal);
  }, [showEditModal]);

  return (
    <>
      {showEditModal && (
        <Modal
          closeRootModal={closeRootModal}
          confirmClose={true}
          dismissError={props.dismissError}
        >
          <EditContributionModal
            closeRootModal={closeRootModal}
            confirmClose={true}
            comment={props.comment}
            item={props.item}
            allowMapOnModal={props.item.implementation.allowMapOnModal}
          />
        </Modal>
      )}
      <div>
        <Dropdown
          focusFirstItemOnShow="keyboard"
          className="ugc-comment-options__dropdown"
          drop={"left"}
        >
          <Dropdown.Toggle as={CustomToggle}/>

          <Dropdown.Menu>
            {options.map((option, i) => (
              <Dropdown.Item
                key={i}
                onClick={(e) => handleDropDownItemClick(option, e)}
              >
                {option}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
}

CommentOptions.propTypes = {
  comment: CommentPropType,
};

export default CommentOptions;
